module.exports = __webpack_public_path__ + "img/moveJob-Active.96658f7b.svg";